const cache = new Map();
class MediaQueryCache {
    constructor() {
        this.get = (cacheKey) => {
            return cache.get(cacheKey);
        };
        this.set = (cacheKey, mediaQuery) => {
            cache.set(cacheKey, mediaQuery);
        };
        this.wipe = () => {
            cache.clear();
        };
    }
}
/** Manages global cache of media queries to reuse them (major performance impact) */
const singleton = new MediaQueryCache();
export { singleton as MediaQueryCache };
//# sourceMappingURL=MediaQueryCache.js.map